import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // For internal navigation links

const Footer = () => {
  // Get the current year dynamically
  const currentYear = new Date().getFullYear();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300); // Show after scrolling 300px
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll); // Cleanup
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-dark text-white py-4 mt-4">
      <div className="container-fluid">
        <div className="row">
          {/* About Section */}
          <div className="col-md-3 mb-3">
            <h5 className="mb-3" style={{fontFamily: 'Caprasimo'}}>WPL Cricinfo</h5>
            <p className="small">
            Discover your go-to source for Women's Premier League (WPL) and Indian Premier League (IPL) updates! Stay updated with scores, highlights, and breaking news, tailored for both dedicated fans and casual viewers. Enjoy in-depth insights into player performances, team standings, and expert analyses to enrich your cricket experience. Celebrate the thrill of WPL and IPL with us, and stay connected for all things cricket!
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-2 mb-3">
            <h5 className="mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/" className="text-white text-decoration-none">Home</Link>
              </li>
              <li>
                <Link to="/fixtures-and-results" className="text-white text-decoration-none">Fixtures & Results</Link>
              </li>
              <li>
                <Link to="/wpl-news-updates" className="text-white text-decoration-none">News & Updates</Link>
              </li>
              <li>
                <Link to="/wpl-teams" className="text-white text-decoration-none">Teams</Link>
              </li>
              <li>
                <Link to="/wpl-team-squads" className="text-white text-decoration-none">Squads</Link>
              </li>
            </ul>
          </div>

          <div className="col-md-3 mb-3">
            <h5 className="mb-3">WPL Teams</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/" className="text-white text-decoration-none">Delhi Capitals Women</Link>
              </li>
              <li>
                <Link to="/" className="text-white text-decoration-none">Gujarat Gaints Women</Link>
              </li>
              <li>
                <Link to="/" className="text-white text-decoration-none">Mumbai Indians Women</Link> <i class="bi bi-trophy"></i> <i class="bi bi-trophy"></i>
              </li>
              <li>
                <Link to="/" className="text-white text-decoration-none">Royal Challengers Bengaluru Women</Link> <i class="bi bi-trophy"></i>
              </li>
              <li>
                <Link to="/" className="text-white text-decoration-none">UP Warriorz Women</Link>
              </li>
            </ul>
          </div>

          <div className="col-md-2 mb-3">
            <h5 className="mb-3">IPL Teams</h5>
            <ul className="list-unstyled">
              <li>
              <span className="badge bg-primary me-1 mb-1">Chennai Super Kings (CSK)</span>
              <span className="badge bg-primary me-1 mb-1">Delhi Capitals (DC)</span>
              <span className="badge bg-primary me-1 mb-1">Gujarat Titans (GT)</span>
              <span className="badge bg-primary me-1 mb-1">Kolkata Knight Riders (KKR)</span>
              <span className="badge bg-primary me-1 mb-1">Lucknow Super Giants (LSG)</span>
              <span className="badge bg-primary me-1 mb-1">Mumbai Indians (MI)</span>
              <span className="badge bg-primary me-1 mb-1">Punjab Kings (PBKS)</span>
              <span className="badge bg-primary me-1 mb-1">Rajasthan Royals (RR)</span>
              <span className="badge bg-primary me-1 mb-1">Royal Challengers Bangalore (RCB)</span>
              <span className="badge bg-primary me-1 mb-1">Sunrisers Hyderabad (SRH)</span>
              </li>
            </ul>
          </div>

          {/* Social Media & Contact */}
          <div className="col-md-2 mb-3">
            <h5 className="mb-3">Follow Us</h5>
            <div className="d-flex gap-2">
              <a href="#" rel="noopener noreferrer" className="text-white" aria-label="Follow us on Twitter">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="#" rel="noopener noreferrer" className="text-white" aria-label="Follow us on Facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#" rel="noopener noreferrer" className="text-white" aria-label="Follow us on Instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#" rel="noopener noreferrer" className="text-white" aria-label="Subscribe on YouTube">
                <i className="bi bi-youtube"></i>
              </a>
            </div>            
          </div>
        </div>

        {/* Copyright */}
        <div className="row mt-3 border-top pt-3">
          <div className="col-md-12 text-center">
            <p className="small mb-0">
              &copy; Copyright {currentYear} WPL Cricinfo. All Rights Reserved.
            </p>
          </div>
        </div>

        {showScrollTop && (
          <button
            onClick={scrollToTop}
            className="btn btn-primary btn-sm position-fixed end-0 bottom-0 m-3"
            title="Scroll to Top"
            aria-label="Scroll to Top"
          >
            <i className="bi bi-arrow-up"></i>
          </button>
        )}
      </div>
    </footer>
  );
};

export default Footer;